import { render, staticRenderFns } from "./RiderStatus.vue?vue&type=template&id=2c06d888&scoped=true"
import script from "./RiderStatus.vue?vue&type=script&lang=js"
export * from "./RiderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06d888",
  null
  
)

export default component.exports